// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Faqs from "./pages/Faqs";
import ContactPage from "./pages/ContactPage";
import NotFound from "./pages/NotFound";
import Footer from "./components/Footer";
// import Reviews from "./pages/reviews";
import { PrivacyPolicy, Terms, ShippingPolicy } from "./components/PolicyPages";
import NotSatisfied from "./pages/SATISFIED";

// Layout component with Navbar
const MainLayout = ({ children }) => (
  <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-white">
    <Navbar />
    {children}
    <Footer />
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Routes with Navbar */}
        <Route
          path="/"
          element={
            <MainLayout>
              <Home />
            </MainLayout>
          }
        />
        <Route
          path="/shop"
          element={
            <MainLayout>
              <Shop />
            </MainLayout>
          }
        />
        <Route
          path="/faqs"
          element={
            <MainLayout>
              <Faqs />
            </MainLayout>
          }
        />
        <Route
          path="/contact"
          element={
            <MainLayout>
              <ContactPage />
            </MainLayout>
          }
        />
        {/* <Route
          path="/reviews"
          element={
            <MainLayout>
              <Reviews />
            </MainLayout>
          }
        /> */}
        <Route
          path="/privacy"
          element={
            <MainLayout>
              <PrivacyPolicy />
            </MainLayout>
          }
        />
        <Route
          path="/terms"
          element={
            <MainLayout>
              <Terms />
            </MainLayout>
          }
        />
        <Route
          path="/shipping&refund"
          element={
            <MainLayout>
              <ShippingPolicy />
            </MainLayout>
          }
        />

        {/* 404 route without Navbar */}
        <Route
          path="/satisfaction-guaranteed"
          element={
            <MainLayout>
              <NotSatisfied />
            </MainLayout>
          }
        />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
